import styled, { css } from "styled-components";

export const Label = styled.main`
  ${({ theme }) => css`
    font-weight: 500;
    padding-top: 1.5rem;
    padding-bottom: 0.5rem;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    font-family: Roboto !important;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.medium};
    }

    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;

export const Select = styled.select`
  ${({ theme, width = "100%", error, valueValid }) => css`
    width: ${width};
    background: none;
    border: 0;
    color: ${theme.colors.gray};
    font-family: Roboto !important;
    font-size: ${theme.font.sizes.medium};
    font-weight: 500;
    /*border-bottom: 1px solid #ddd;*/
    border-bottom: ${error
      ? "1px solid #f00909"
      : valueValid
      ? `1px solid ${theme.colors.lineBlue}`
      : "1px solid #ddd"};

    transform: translateX(-4px);
  `}
`;

export const Option = styled.option`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    padding: 0.5rem;
    cursor: pointer;
    font-size: ${theme.font.sizes.medium};
    font-family: Roboto !important;

    &:last-child {
      border: none;
    }
  `}
`;
